/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hero_Badge_PhysioInputs */

const en_hero_badge_physio = /** @type {(inputs: Hero_Badge_PhysioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Physiotherapy`)
};

const pl_hero_badge_physio = /** @type {(inputs: Hero_Badge_PhysioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fizjoterapia`)
};

/**
* | output |
* | --- |
* | "Physiotherapy" |
*
* @param {Hero_Badge_PhysioInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const hero_badge_physio = /** @type {((inputs?: Hero_Badge_PhysioInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hero_Badge_PhysioInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_hero_badge_physio(inputs)
	return en_hero_badge_physio(inputs)
});